const SignatureSection = ({ data }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px' }}>
          Declaration By Candidate
        </td>
      </tr>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px' }}>
  {
    data.gender === 1 ? (
      <>
        मैं प्रमाणित करता हूँ कि आवेदन पत्र में मेरे द्वारा भरा गया है तथा आवेदन पत्र में भरे गये सभी विवरण सत्य हैं।
        यदि कोई प्रविष्टि असत्य सिद्ध हो तो मेरा प्रवेश निरस्त कर दिया जाये।<br />
        मैं घोषणा करता हूँ कि जब तक मैं विद्यालय में संस्थागत विद्यार्थी रहूँगा, महाविद्यालय के नियमों का पालन करूँगा।
        महाविद्यालय विरोधी अथवा समाज विरोधी कार्यवाही में भाग नहीं लूंगा।<br />
        मैं आचरण एवं व्यवहार ठीक रखूँगा और महाविद्यालय में नियमित रूप से उपस्थित रहूँगा।
        महाविद्यालय में मेरी उपस्थिति 75% से कम होने पर यदि मुझे परीक्षा से रोका जाता है तो मुझे कोई आपत्ति नहीं होगी।<br />
        मैंने किसी अन्य महाविद्यालय अथवा विश्वविद्यालय में प्रवेश नहीं लिया है।
        अदेय तथा उपस्थिति प्रमाण पत्र प्रस्तुत करने पर ही मुझे विश्वविद्यालय परीक्षा प्रवेश पत्र निर्गत किया जाएगा।
      </>
    ) : (
      <>
        मैं प्रमाणित करती हूँ कि आवेदन पत्र में मेरे द्वारा भरा गया है तथा आवेदन पत्र में भरे गये सभी विवरण सत्य हैं।
        यदि कोई प्रविष्टि असत्य सिद्ध हो तो मेरा प्रवेश निरस्त कर दिया जाये।<br />
        मैं घोषणा करती हूँ कि जब तक मैं विद्यालय में संस्थागत विद्यार्थी रहूँगी, महाविद्यालय के नियमों का पालन करूँगी।
        महाविद्यालय विरोधी अथवा समाज विरोधी कार्यवाही में भाग नहीं लूंगी।<br />
        मैं आचरण एवं व्यवहार ठीक रखूँगी और महाविद्यालय में नियमित रूप से उपस्थित रहूँगी।
        महाविद्यालय में मेरी उपस्थिति 75% से कम होने पर यदि मुझे परीक्षा से रोका जाता है तो मुझे कोई आपत्ति नहीं होगी।<br />
        मैंने किसी अन्य महाविद्यालय अथवा विश्वविद्यालय में प्रवेश नहीं लिया है।
        अदेय तथा उपस्थिति प्रमाण पत्र प्रस्तुत करने पर ही मुझे विश्वविद्यालय परीक्षा प्रवेश पत्र निर्गत किया जाएगा।
      </>
    )
  }
</td>

      </tr>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px', paddingTop: '5px' }}>
  {
    data.gender === 1 ? (
      <>
        मैं विश्वास दिलाता हूँ कि श्री _________________ मेरे संरक्षण में रहेंगे।
        वह अपना आचरण एवं व्यवहार उचित रखेंगे। यदि वे महाविद्यालय के नियमों का उल्लंघन करते हैं और उन्हें
        महाविद्यालय से निष्कासित किया जाता है, तो मुझे कोई आपत्ति नहीं होगी।<br /><br />
        <strong>नोट:</strong> प्रवेश के समय अभिभावक का छात्र के साथ महाविद्यालय में उपस्थित होना अनिवार्य है।
      </>
    ) : (
      <>
        मैं विश्वास दिलाती हूँ कि कुमारी / श्रीमती _________________ मेरे संरक्षण में रहेंगी।
        वह अपना आचरण एवं व्यवहार उचित रखेंगी। यदि वे महाविद्यालय के नियमों का उल्लंघन करती हैं और उन्हें
        महाविद्यालय से निष्कासित किया जाता है, तो मुझे कोई आपत्ति नहीं होगी।<br /><br />
        <strong>नोट:</strong> प्रवेश के समय अभिभावक का छात्रा के साथ महाविद्यालय में उपस्थित होना अनिवार्य है।
      </>
    )
  }
</td>

      </tr>
    </tbody>
  </table>
);

export default SignatureSection;